{
  "it": {
    "decision_type": {
      "actions": {
        "add_competitor": "Aggiungi concorrente",
        "add_decision_partners": "Partner della decisione",
        "auto_share_proposals": "Condividi automaticamente le proposte approvate",
        "change_rights": "Modifica diritti",
        "collapse": "Comprimi",
        "create_category": "Aggiungi nuova categoria",
        "delete": "Elimina",
        "deleteMultiple": "Elimina...",
        "delete_cancel": "Annulla",
        "delete_group": "Elimina gruppo di partner",
        "download": "Scarica",
        "edit": "Modifica",
        "edit_decision_partners": "Modifica partner della decisione",
        "import": "Importa",
        "manage": "Gestisci",
        "new": "Nuovo",
        "newDecision": "Nuova decisione",
        "newDecisions": "Decisione",
        "save": "Salva",
        "show": "Mostra",
        "start_new_group": "Avvia nuovo gruppo",
        "submit": "Salva"
      },
      "attributes": {
        "category": "Categoria",
        "created_at": "Creato il",
        "description": "Descrizione",
        "name": "Titolo",
        "responsible": "Responsabile",
        "start_date": "Data di inizio"
      },
      "labels": {
        "add_decision_partners": "Aggiungi partner della decisione",
        "allowCreditExplainer": "Mostra il credito per le proposte sotto budget",
        "auto_close": "Chiudi automaticamente la decisione una volta superata la scadenza",
        "auto_close_info": "Chiudere una decisione impedisce al cliente di approvare una proposta quando non è stata presa alcuna decisione. Utile quando lavora con scadenze ravvicinate.",
        "auto_share": "Condivisione automatica",
        "auto_share_description": "Condivide automaticamente le proposte approvate con questo gruppo di partner",
        "auto_share_subtitle": "Quando viene approvata una nuova proposta",
        "auto_share_title": "Condividi automaticamente le proposte approvate",
        "category_name": "Nome categoria",
        "closes_on_deadline": "Si chiude alla scadenza",
        "createNewPartner": "Oppure crei un nuovo partner della decisione",
        "decision_type_category_description": "Assegnando una categoria come cucina, bagno ecc. a più decisioni, queste verranno raggruppate per una migliore visione d'insieme",
        "deleteCategory": "Eliminare la categoria {category}?",
        "deleteGroupSubtitle": "Questa azione rimuoverà tutte le conversazioni, le proposte e i documenti creati da tutti i membri di {group_name} da {decision_type_name}.",
        "deleteGroupTitle": "Sta per eliminare {group_name}",
        "disclaimerDeleteGroup": "Eliminando {group_name}, la pubblicazione di tutte le decisioni per i partner verrà annullata. Potrà pubblicare di nuovo per i partner della decisione non appena questa decisione avrà nuovamente dei partner.",
        "disclamerDeleteCategory": "Eliminando {category}, la categoria verrà rimossa da tutte le decisioni a cui è assegnata. Le decisioni non verranno eliminate.",
        "editCategory": "Modifica categoria",
        "editGroup": "Modifica {group_name}",
        "editPartnerRights": "Modifica diritti di comunicazione dei partner della decisione",
        "editPartnerRightsLater": "Può sempre modificarlo in seguito",
        "edit_partner_group_eyebrow": "Modifica gruppo di partner",
        "existing_groups": "Gruppi di partner esistenti",
        "explainerPartners": "Aggiunga partner esterni della decisione e collabori su {decision_type_name}",
        "export_preparing": "La raccolta di tutte le proposte può richiedere alcuni minuti. Riceverà una notifica quando sarà pronta per lo scaricamento.",
        "export_proposals_approved": "Documenti delle proposte approvate",
        "for_decision": "Per la decisione",
        "groupRightsWarning": "Attenzione: tutte le conversazioni tra il cliente e i partner verranno rimosse. Questa azione è irreversibile. È sicuro di voler continuare?",
        "hint": "Può gestire le Sue categorie nelle",
        "hintSettings": "impostazioni dell'azienda.",
        "last_updated_at": "Ultimo aggiornamento il",
        "matrix": "Statistiche",
        "new_category": "Nuova categoria di decisione",
        "new_partner_group": "Nuovo gruppo di partner",
        "noPartnersAddedYet": "Nessun partner della decisione ancora aggiunto",
        "noResultPartner": "Nessun risultato per {partner_name}",
        "partner_already_in_other_group": "Già in un altro gruppo",
        "partner_already_selected": "Già selezionato",
        "partner_group": "Gruppo di partner",
        "partner_group_footer_empty": "Selezioni almeno 1 partner",
        "partner_group_footer_summary": "{count} partner • {rights} | {count} partner • {rights} | {count} partner • {rights}",
        "partner_group_name_label": "Nome del gruppo di partner",
        "partner_groups": "Gruppi di partner",
        "partners": "Partner della decisione",
        "partners_count": "Nessun partner | 1 partner | {count} partner",
        "partners_in_group": "Partner in questo gruppo",
        "partners_in_total": "Nessun partner in totale | 1 partner in totale | {count} partner in totale",
        "partners_selected_count": "Nessuno selezionato | 1 selezionato | {count} selezionati",
        "permissions_label": "Diritti del gruppo",
        "projectUnitsTotal": "{project_name} ha in totale {units_count_max} unità",
        "proposal_uploaded": "proposta caricata",
        "published_state": "Stato di pubblicazione",
        "searchPartners": "Cerca partner della decisione",
        "selectADecision": "Seleziona una decisione",
        "select_decision_partners": "Selezioni i Suoi partner della decisione",
        "setUpPartners": "Imposta partner della decisione",
        "set_rights": "Imposta i diritti del gruppo per {partner_group_name}",
        "share_existing_title": "Condividi proposte esistenti",
        "share_proposals_label": "Condividi proposte",
        "start_date_description": "Data solo per uso interno. Può essere utilizzata per determinare l'ordine in cui il Suo team lavora sulle decisioni",
        "start_date_title": "Data di inizio (facoltativa)",
        "step0Title": "Quale progetto modello e decisione desidera utilizzare?",
        "step1Title": "Che tipo di decisione devono prendere i Suoi clienti?",
        "tab_proposal_templates": "Modelli di proposta",
        "tab_units": "Unità",
        "upsellCategoryTypes": "Questa funzionalità non è inclusa nel Suo pacchetto. Ci contatti tramite il pulsante blu per saperne di più.",
        "view": "Visualizza",
        "view_list": "Elenco",
        "view_table": "Tabella",
        "writeEmployeeNameReject": "Scriva <i><b>{employeeName}</b></i> per continuare."
      },
      "snackbars": {
        "duplicate": "La decisione è stata creata; tuttavia, il processo di copia dal modello potrebbe richiedere alcuni minuti per essere completato."
      },
      "toasts": {
        "bulk_delete": "Decisione eliminata con successo | Decisioni eliminate con successo",
        "update": "Decisione aggiornata con successo"
      },
      "validation": {
        "duplicateNameAlreadyTaken": "'{name}' è già utilizzato per questo progetto",
        "nameAlreadyTaken": "Il nome è già utilizzato per questo progetto",
        "needName": "Titolo obbligatorio",
        "projectRequired": "Selezioni prima un progetto",
        "selectDecisionType": "Selezioni almeno 1 decisione",
        "selectSharingOption": "Selezioni con chi desidera condividere il/i documento/i"
      }
    }
  }
}
